import { render } from "./VideoBanner.vue?vue&type=template&id=353b72a2&scoped=true"
import script from "./VideoBanner.vue?vue&type=script&lang=js"
export * from "./VideoBanner.vue?vue&type=script&lang=js"

import "./VideoBanner.vue?vue&type=style&index=0&id=353b72a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353b72a2"]])

export default __exports__